import { Fragment, useContext, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";

import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import PageHeader from "../component/layout/pageheader";
import CartTotals from "../component/section/CartTotal";

import { ShopContext } from "../context/ShopContext";

const PlaceOrder = () => {
  const [method, setMethod] = useState("cod");


  const {
    navigate,
    backendUrl,
    token,
    cartItems,
    setCartItems,
    getCartAmount,
    delivery_fee,
    products,
  } = useContext(ShopContext);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    street: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    phone: "",
  });

  /* ================= FORM HANDLER ================= */
  const onChangeHandler = (e) => {
    setFormData((data) => ({
      ...data,
      [e.target.name]: e.target.value,
    }));
  };

/* DISABLED
  const initPay = (order) => {
    const options = {
      key: import.meta.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: order.amount,
      currency: order.currency,
      name: 'Order Payment',
      description: 'Order Payment',
      order_id: order.id,
      receipt: order.receipt,
      handler: async (response) => {
        console.log(response)
        
        try {
          const {data} = await axios.post(backendUrl + '/api/order/verifyRazorpay', response, {headers: {token}})
          if (data.success) {
            navigate('/orders')
            setCartItems({})
          }
        } catch (error) {
          console.log(error);
          toast.error(error)
          
        }
      }
    }

    const rzp = new window.Razorpay(options)
    rzp.open()
  }

*/

  /* ================= PLACE ORDER ================= */
  const onSubmitHandler = async (e) => {
    console.log("FORM SUBMITTED — method =", method);

    e.preventDefault();

    try {
      let orderItems = [];

      for (const items in cartItems) {
        for (const item in cartItems[items]) {
          if (cartItems[items][item] > 0) {
            const itemInfo = structuredClone(
              products.find((p) => p._id === items)
            );
            if (itemInfo) {
              itemInfo.size = item;
              itemInfo.quantity = cartItems[items][item];
              orderItems.push(itemInfo);
            }
          }
        }
      }

      {/* remove log later*/}
      console.log(orderItems);
      

      let orderData = {
        address: formData,
        items: orderItems,
        amount: getCartAmount() + delivery_fee,
      };

      switch (method) {

        //API Calls for COD
        case 'cod':
          const response = await axios.post(backendUrl + '/api/order/place', orderData, {headers: {token}})
          console.log(response.data);
          
          if (response.data.success) {
            setCartItems({})
            navigate('/orders')
          } else {
            toast.error(response.data.message)
          }
          break;

        case 'stripe': 
 
          
          const responseStripe = await axios.post(backendUrl + '/api/order/stripe', orderData, {headers: {token}})
          if (responseStripe.data.success) {
            const {session_url} = responseStripe.data

  
            window.location.replace(session_url)
          } else {
            toast.error(responseStripe.data.message)
          }
                  
          break;
/*DISABLED
        case 'razorpay':
          const responseRazorpay = await axios.post(backendUrl + '/api/order/razorpay', orderData, {headers: {token}})
          if (responseRazorpay.data.success) {
            initPay(responseRazorpay.data.order);
                        
          }
          break;
*/
        default:
          break;
      }


    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  return (
    <Fragment>
      <Header />
      <PageHeader title="PLACE ORDER" curPage="PLACE ORDER" />

      <div className="shop-cart padding-top padding-bottom">
        <div className="container">
          <div className="section-wrapper">

            <form onSubmit={onSubmitHandler} className="po-grid">

              {/* ================= LEFT : DELIVERY ================= */}
              <div className="po-card">
                <h4 className="po-title">Delivery Information</h4>

                <div className="row g-3">
                  <div className="col-md-6">
                    <input
                      required
                      name="firstName"
                      value={formData.firstName}
                      onChange={onChangeHandler}
                      className="form-control"
                      placeholder="First Name"
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      required
                      name="lastName"
                      value={formData.lastName}
                      onChange={onChangeHandler}
                      className="form-control"
                      placeholder="Last Name"
                    />
                  </div>

                  <div className="col-md-12">
                    <input
                      required
                      name="email"
                      value={formData.email}
                      onChange={onChangeHandler}
                      className="form-control"
                      placeholder="Email Address"
                    />
                  </div>

                  <div className="col-md-12">
                    <input
                      required
                      name="street"
                      value={formData.street}
                      onChange={onChangeHandler}
                      className="form-control"
                      placeholder="Street Address"
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      required
                      name="city"
                      value={formData.city}
                      onChange={onChangeHandler}
                      className="form-control"
                      placeholder="City"
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      required
                      name="state"
                      value={formData.state}
                      onChange={onChangeHandler}
                      className="form-control"
                      placeholder="State"
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      required
                      name="zipcode"
                      value={formData.zipcode}
                      onChange={onChangeHandler}
                      className="form-control"
                      placeholder="Zip Code"
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      required
                      name="country"
                      value={formData.country}
                      onChange={onChangeHandler}
                      className="form-control"
                      placeholder="Country"
                    />
                  </div>

                  <div className="col-md-12">
                    <input
                      required
                      name="phone"
                      value={formData.phone}
                      onChange={onChangeHandler}
                      className="form-control"
                      placeholder="Phone Number"
                    />
                  </div>
                </div>
              </div>

              {/* ================= RIGHT : SUMMARY ================= */}
              <div className="po-card po-summary">
                <CartTotals />

                <h4 className="po-title po-mt">Payment Method</h4>

                <div className="po-payment">
                  <label>
                    <input
                      type="radio"
                      checked={method === "cod"}
                      onChange={() => setMethod("cod")}
                    />
                    <span>Cash on Delivery</span>
                  </label>

                  <label>
                    <input
                      type="radio"
                      checked={method === "stripe"}
                      onChange={() => setMethod("stripe")}
                    />
                    <span>Stripe</span>
                  </label>
{/*DISABLED
                  <label>
                    <input
                      type="radio"
                      checked={method === "razorpay"}
                      onChange={() => setMethod("razorpay")}
                    />
                    <span>Razorpay</span>
                  </label>
*/}
                </div>

                <button
                  type="submit"
                  className="default-button w-100 po-btn"
                >
                  <span>Place Order</span>
                </button>
              </div>

            </form>

          </div>
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default PlaceOrder;
